import React from "react";
import { Link } from "react-router-dom";
import { BsCashStack, BsCalculator, BsBuilding, BsPeople } from "react-icons/bs";
import { MdOutlinePayments } from "react-icons/md";

const EmployeeNav = () => {
    return (
        <div className="nav-panel">
            <ul>
                <li><Link to="/emp-dashboard"><BsBuilding style={{ color: "#28e326" }} title="Home"/></Link></li>
                <li><Link to="/emp-dashboard/pay-summary"><BsPeople style={{ color: "#28e326" }} title="Pay Summary" /></Link></li>
                <li><Link to="viewpayroll"><BsCashStack style={{ color: "#28e326" }} title="Documents"/></Link></li>
                <li><Link to="/emp-dashboard/emp-request"><MdOutlinePayments style={{ color: "#28e326" }} title="Leave Request" /></Link></li>
                <li><Link to="/emp-dashboard/emp-benefits-summary"><BsCalculator style={{ color: "#28e326" }} title="Insurance" /></Link></li>
                

            </ul>
        </div>
    );
};

export default EmployeeNav;
